import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ValidatedTextInputV2, Dropdown, Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Title, Message, Button } from 'src/core/components';
import { sense5ModOptions, sense3ModOptions } from 'src/constants/forms';
import messages from 'src/components/EditSequence/messages';

import { PRIMER_NAME, OLIGO_SEQUENCE, MODIFICATION_3, MODIFICATION_5 } from './constants';
import './PlateWellsForm.style.scss';

const PlateWellsFormComponent = ({
  onChangeField,
  formState,
  onPreview,
  validators,
  intl,
}) => (
  <div className="plate-wells-form" data-testid="plate-wells-form">
    <Title size="4" message={messages.plateWells} font="medium" />
    <Spacer bottom="16" />

    <ValidatedTextInputV2
      data-testid="primer-name-input"
      label={<Message message={messages.primerName} />}
      required
      showOnlyOneError
      value={formState[PRIMER_NAME]?.value}
      onChange={
        (value, e, canValidate, isValid) => onChangeField(value, PRIMER_NAME, isValid)
      }
      initialValidation={!!formState[PRIMER_NAME]?.value}
      validators={validators[PRIMER_NAME]}
    />

    <div className="plate-wells-form__preview-btn-wrapper">
      <Button
        data-testid="preview-oligo-sequence-btn"
        type="tertiary"
        onClick={onPreview}
        label={messages.preview}
        className="plate-wells-form__preview-btn"
      />
    </div>

    <ValidatedTextInputV2
      data-testid="oligo-sequence-input"
      className="plate-wells-form__textarea"
      label={<Message message={messages.oligoSequence} />}
      required
      textarea
      showOnlyOneError
      value={formState[OLIGO_SEQUENCE]?.value}
      validators={validators[OLIGO_SEQUENCE]}
      initialValidation={!!formState[OLIGO_SEQUENCE]?.value}
      onChange={(
        value,
        e,
        canValidate,
        isValid
      ) => onChangeField(value.toUpperCase(), OLIGO_SEQUENCE, isValid)}
    />

    <div className="base-count" data-testid="base-count-wrapper">
      <Message message={{
        ...messages.baseCount,
        values: { count: formState[OLIGO_SEQUENCE]?.value?.length || 0 },
      }}
      />
    </div>

    <Spacer bottom="40" />

    <div className="plate-wells-form__mod-dropdowns" data-testid="plate-wells-form-dropdowns">
      <Dropdown
        data-testid="modification-5-dropdown"
        className="plate-wells-form__dropdown"
        label={<Message message={messages.modification5} />}
        onSelect={(option) => onChangeField(option.value, MODIFICATION_5, true)}
        selectedOptions={{ value: formState[MODIFICATION_5]?.value }}
        placeholder={intl.formatMessage(messages.none)}
      >
        {sense5ModOptions.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </Dropdown>

      <Dropdown
        data-testid="modification-3-dropdown"
        className="plate-wells-form__dropdown"
        label={<Message message={messages.modification3} />}
        onSelect={(option) => onChangeField(option.value, MODIFICATION_3, true)}
        selectedOptions={{ value: formState[MODIFICATION_3]?.value }}
        placeholder={intl.formatMessage(messages.none)}
      >
        {sense3ModOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Dropdown>
    </div>
  </div>
);

PlateWellsFormComponent.propTypes = {
  formState: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  validators: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(PlateWellsFormComponent);
